module.exports = __webpack_public_path__ + "static/media/movie.dce17255.png";